class VariantPicker extends HTMLElement {
  inputs; product; variants; variant; input;

  connectedCallback() {
    this.inputs = this.querySelectorAll('input[type="radio"]');
    this.input = this.querySelector('input[name="id"]');
    this.init();
  }

  init = () => {
    this.inputs.forEach(input => {input.addEventListener('change', () => this.handleChange())});
  }

  handleChange = () => {
    if(this.variants){
      if(this.isSelected()){
        this.findSelected();
        this.dispatchEvent(new CustomEvent(Utils.E_VARIANT_CHANGING, { detail: this.variant }));
        if(this.variant != undefined){
          this.input.value = this.variant.id;
          this.dispatchEvent(new CustomEvent(Utils.E_VARIANT_CHANGE, { detail: this.variant }));
        }
      } else {
        this.checkAvailability();
      }
    } else {
      this.variants = this.closest('product-card').getVariants();
      if(this.variants){
        this.handleChange();
      } else {
        this.getVariants(() => this.handleChange());
      }
    }
  } 

  getVariants = (callback) => {
    Utils.getProduct(this.dataset.product, {
      success: (product) => {
        this.variants = product.variants;
        if(typeof callback === 'function'){
          callback();
        }
      }
    });
  } 

  checkAvailability = () => {
    const selectedOptions = Array.from(this.inputs).filter(input => input.checked).map(input => input.value);
    const data = new FormData(this.input.form);
    this.variants.forEach(variant => {
      const variantSelected = variant.options.filter(option => selectedOptions.includes(option));
      if(variantSelected.length === selectedOptions.length){ 
        variant.options.forEach((option, index) => {
          if(!data.get(`option[${index+1}]`)){
            const input = this.querySelector(`input[name="option[${index+1}]"][value="${option}"]`);
            input.disabled = !variant.available;
          }
        });
      }
    });
  }

  findSelected = () => {
    this.variant = this.variants.find(variant => {
      const selectedOptions = Array.from(this.inputs).filter(input => input.checked).map(input => input.value);
      return variant.options.every(option => selectedOptions.includes(option));
    });
  }

  isSelected = () => {
    const groupedInputs = Array.from(this.inputs).reduce((acc, input) => {
      const name = input.getAttribute('name');
      if (!acc[name]) {
        acc[name] = [];
      }
      acc[name].push(input);
      return acc;
    }, {});

    return Object.values(groupedInputs).every(inputs => inputs.some(input => input.checked));
  }
}
if (!customElements.get('variant-picker')) {
  customElements.define('variant-picker', VariantPicker);
}

class ProductCard extends HTMLElement {
  variantPicker; loader; form; button; data; scriptData;

  connectedCallback() {
    this.variantPicker = this.querySelector('variant-picker');
    this.loader = this.querySelector('theme-loader');
    this.form = this.querySelector('form');
    this.button = this.querySelector('[data-add]');
    this.scriptData = this.querySelector('script[data-describe="product-card"]');
    this.init();
  }

  init = () => {
    if(this.variantPicker != undefined){
      this.variantPicker.addEventListener(Utils.E_VARIANT_CHANGE, () => this.addToCart());
    }
    if(this.button != undefined){
      this.button.addEventListener('click', () => this.addToCart());
    }
    if(this.scriptData){
      this.data = JSON.parse(this.scriptData.innerText);
      this.querySelectorAll('a').forEach(a => a.addEventListener('click', (e) => {
        Shopify.analytics.publish(Utils.E_PRODUCT_CLICKED, this.data);
        window.dispatchEvent(new CustomEvent(Utils.E_PRODUCT_CLICKED, { detail: this.data }));
        this.dispatchEvent(new CustomEvent(Utils.E_PRODUCT_CLICKED, { detail: this.data }));
      }));
    }
  }

  addToCart = () => {
    this.showLoader();
    Utils.addTocart({
      form: this.form,
      finally: () => this.hideLoader()
    });
  }

  showLoader = () => {
    if(this.loader)
      this.loader.show();
  }

  hideLoader = () => {
    if(this.loader)
      this.loader.hide();
  }

  getVariants = () => {
    return this.scriptData ? this.data.product.variants : null;
  }
}
if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard);
}